<div class="system-attribute-container" *ngIf="!containsError">
  <div>
    <div>
    <span class="pageHeader" id="updateSystemAttributesHeader">

								Update System Attributes
								</span>

    </div>
    <br><br><br>

    <div *ngIf="successMess">
      <div class="successMessAlign">
        <p>
        <li>System Attribute has been successfully updated.</li>
        </p>
      </div>
    </div>
    <div class="error-container" *ngIf="showErrorDiv">
      <p>{{errHeading}}</p>
      <p>
      <li> {{errMessage}}</li>
      </p>
    </div>
    <span class="adminTblAlign">
        <div class="ui-g-3 lblAlign"> System Attribute:  </div>
        <div class="ui-g-3">   <fm-select
          [options]="sysAttr"
          [(ngModel)]="selectedAttr"
        ></fm-select></div>
      </span><br>
    <div class="btnAlign">
      <button fmButton type="button" [small]="true" [primary]="true" label="Search" class="dispbuttonMargin"
              (click)="getSystemAttr()"></button>
      <button fmButton type="button" routerLink="/mainMenu" [small]="true" label="Cancel"
              class="dispbuttonMargin"></button>
    </div>
  </div>
  <br>
  <div class="resultTbl" *ngIf="loader">
    <table class="lblAlign">
      <tr>
        <td>System Attribute Name:</td>
        <td class="resultLblAlign">{{attrName}}</td>
      </tr>
      <tr>
        <td>System Attribute Value:</td>
        <td class="resultLblAlign">
          <fm-select
            [options]="flagVal"
            [(ngModel)]="selectedFlag"
            ariaLabelledBy="default"
          ></fm-select>
        </td>
      </tr>
    </table>
    <div>
      <button fmButton type="button" [small]="true" [primary]="true" label="Update"
              class="update-button-dev-attr" (click)="updateSystemAttributesLimit()"></button>
    </div>
  </div>
</div>
<app-error-page [errorMsg]="errorMsg" *ngIf="containsError"></app-error-page>
